import React, { Component } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import MigrosLoginButton from 'components/migros-login-button';
import ProductSlider from 'components/contentpage-product-slider';
import { PROFILE_CUMULUS_PRODUCTS } from 'constants/page-names';
import { Trans } from 'translations';

/**
 * @extends Component<IFavouriteProductsSliderComponent>
 */
class FavouriteProductsSlider extends Component {
    static propTypes = {
        logged_out_text: PropTypes.string,
        cumulus_not_linked_text: PropTypes.string,
        title: PropTypes.string,
        most_purchased_cumulus: PropTypes.shape({
            link: PropTypes.shape({ to: PropTypes.string, label: PropTypes.string }),
            //products: PropTypes.array,
        }),

        // Redux data
        hasCumulus: PropTypes.bool.isRequired,
        isAuthenticated: PropTypes.bool.isRequired,
        routerRegistry: PropTypes.object.isRequired,
        endpoints: PropTypes.object.isRequired,
        favoriteProducts: PropTypes.array.isRequired,
        populateFavoriteProducts: PropTypes.func.isRequired,
    };


    state = {
        isLoading: true,
    };

    componentDidMount() {
        const { isAuthenticated, hasCumulus } = this.props;

        if (!isAuthenticated || !hasCumulus) {
            this.setState({ isLoading: false });
            return;
        }

        this.props.populateFavoriteProducts().then(() => {
            if (!this._isUnmounted) {
                this.setState({ isLoading: false });
            }
        });
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    _isUnmounted = false;

    renderNotification = () => {
        const { isAuthenticated, hasCumulus, cumulus_not_linked_text, logged_out_text, title } = this.props;

        if (isAuthenticated && !hasCumulus) {
            return (
                <div>
                    <h1 className="cms-most-purchased-cumulus--title">{ title }</h1>
                    <div
                        className="cms-most-purchased-cumulus--cumulus-not-linked"
                        dangerouslySetInnerHTML={ { __html: cumulus_not_linked_text } }
                    />

                    <a href={ this.props.endpoints.userConnectCumulus() } target='_blank'>
                        <Trans path="link.to.cumulus.card.button_dashboard"/>
                    </a>
                </div>
            );
        }

        if (!isAuthenticated) {
            return (
                <div>
                    <h1 className="cms-most-purchased-cumulus--title">{ title }</h1>
                    <div className="cms-most-purchased-cumulus--logged-out">
                        <div dangerouslySetInnerHTML={ { __html: logged_out_text } }/>
                        <div>
                            <MigrosLoginButton inline big/>
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    };

    renderProducts() {
        const { title, favoriteProducts, routerRegistry } = this.props;

        return (
            <div className="cms-most-purchased-cumulus--products">
                <ProductSlider
                    skipTests={ true }
                    title={ title }
                    products={ favoriteProducts }
                    link={ routerRegistry.get(PROFILE_CUMULUS_PRODUCTS).url }
                />
            </div>
        );
    }

    render() {
        const { hasCumulus, isAuthenticated, favoriteProducts } = this.props;
        const couldFetchProducts = hasCumulus && isAuthenticated;
        const hasNotEnoughProducts = couldFetchProducts && favoriteProducts && favoriteProducts.length < 1;

        if (hasNotEnoughProducts) {
            return null;
        }

        return (
            <div className="favourite-products-slider">
                { couldFetchProducts ? this.renderProducts() : this.renderNotification() }
            </div>
        );
    }
}


export default connect(
    reduxUtils.mapStateToProps({
        hasCumulus: 'user.cumulus_connected',
        isAuthenticated: 'user.isAuthenticated',
        routerRegistry: 'router.registry',
        endpoints: 'router.endpoints',
        favoriteProducts: 'user.favoriteProducts',
    }),
    reduxUtils.mapDispatchToProps({
        populateFavoriteProducts: 'user.populateFavoriteProducts',
    }),
)(FavouriteProductsSlider);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/favourite-products-slider/index.js